import { useEffect, useRef, RefObject } from 'react'

/**
 * Usage: On the element inside your drawer/dialog that gets focused when it opens, add the ref that is returned from this hook.
 * This will prevent the element from being focused when the drawer/dialog opens.
 */

const usePreventDialogAutoFocus = (): RefObject<HTMLElement> => {
  const ref = useRef<HTMLElement>(null)

  // prevent focus on element when drawer opens
  useEffect(() => {
    requestAnimationFrame(() => {
      if (ref.current) {
        ref.current.blur()
      }
    })
  }, [])

  return ref
}

export default usePreventDialogAutoFocus
